import styled from 'styled-components/macro';
import { FONT_FAMILY, FONTS } from 'utils/styles/fonts';
import { COLORS } from 'utils/styles/colors';
import { FLEX_CONTAINER } from 'utils/styles/flex';
import { deviceMax } from 'utils/styles/breakpoints';

export const DeleteUserAccountBlock = styled.div`
  width: 100%;
  padding-right: 20px;
  padding-bottom: 20px;

  @media only screen and ${deviceMax.mobileL} {
    padding: 10px;
  }
`;

export const Form = styled.form`
  ${FLEX_CONTAINER.FlexColumn};
  align-items: unset;
  gap: 30px;
  padding: 50px 150px 80px 150px;

  @media only screen and ${deviceMax.laptopLMax} {
    padding: unset;
    ${FLEX_CONTAINER.FlexCenterColumn};
  }
`;

export const QuestionToUser = styled.div`
  ${FONT_FAMILY.FontRegular}
  ${FONTS.font18}
  color: ${COLORS.mainColor};

  @media only screen and ${deviceMax.mobileL} {
    ${FONTS.font14};
  }
`;

export const PurposeOfDeleteAccountBlock = styled.div`
  ${FLEX_CONTAINER.FlexColumn};
  align-items: unset;
  row-gap: 20px;
  width: 320px;
  padding-top: 20px;

  @media only screen and ${deviceMax.laptopLMax} {
    padding-left: 34px;
  }
`;

export const InputContainer = styled.div``;

export const PurposeContainer = styled.label`
  ${FLEX_CONTAINER.FlexRow};
  gap: 10px;
  width: 100%;
`;

export const PurposeText = styled.span`
  color: ${({ error }) => (error ? COLORS.red : COLORS.mainColor)};
  ${FONTS.font16};
  ${FONT_FAMILY.FontRegular};
  cursor: pointer;

  @media only screen and ${deviceMax.mobileL} {
    ${FONTS.font12};
  }
`;

export const InputBlock = styled.div`
  position: relative;
  margin-top: 40px;
  width: 250px;
`;

export const StyledInput = styled.input`
  ${FONTS.font16};
  width: 100%;
  height: 36px;
  border: none;
  outline: none;
  background: none;
  border-bottom: 1px solid ${COLORS.mainColor};

  &::placeholder {
    ${FONTS.font16}
    ${FLEX_CONTAINER.FlexRow};
    color: ${COLORS.mainColor};
    ${FONT_FAMILY.FontLight}
  }

  @media only screen and ${deviceMax.mobileL} {
    &::placeholder {
      ${FONTS.font12}
    }
  }
`;

export const PasswordVisibleIcon = styled.img`
  position: absolute;
  right: 0px;
  top: 12px;
  width: 26px;
  cursor: pointer;

  @media only screen and ${deviceMax.desktop} {
    width: 20px;
  }

  @media only screen and ${deviceMax.mobileL} {
    width: 16px;
  }
`;

export const DeleteAccountButton = styled.div`
  padding-bottom: 28px;

  @media only screen and ${deviceMax.tablet} {
    padding-bottom: 100px;
  }
`;

export const DeleteButton = styled.button`
  width: 254px;
  height: 40px;
  background: none;
  border: 2px solid ${COLORS.mainColor};
  color: ${COLORS.mainColor};
  ${FONTS.font16}
  border-radius: 10px;
`;

export const ModalForSubmit = styled.div`
  position: fixed;
  z-index: 1;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  overflow: auto;
  background-color: ${COLORS.blackWithOpacity};
  display: flex;
  justify-content: center;
  align-items: center;

  @media only screen and ${deviceMax.laptopLMax} {
    padding-top: 150px;
  }

  @media only screen and ${deviceMax.laptopL} {
    padding-top: 200px;
  }
`;

export const ModalContent = styled.div`
  width: 392px;
  padding: 30px;
  border-radius: 12px;
  background: ${COLORS.white};

  @media only screen and ${deviceMax.mobileL} {
    width: 270px;
  }
`;

export const QuestionBlock = styled.div`
  ${FLEX_CONTAINER.FlexColumn};
  align-items: unset;
  gap: 20px;
  width: 100%;
  height: 100%;
`;

export const FinalQuestion = styled.div`
  ${FONTS.font16};
  ${FONT_FAMILY.FontRegular};
  text-align: center;

  @media only screen and ${deviceMax.mobileL} {
    ${FONTS.font12};
  }
`;

export const AnsweringBlock = styled.div`
  ${FLEX_CONTAINER.FlexSpaceBetweenRow};
  width: 100%;
  padding: 0px 20px;

  @media only screen and ${deviceMax.mobileL} {
    padding: 0px 10px;
  }
`;

export const ButtonYes = styled.button`
  background: ${COLORS.mainColor};
  color: ${COLORS.white};
  padding: 11px 50px;
  border-radius: 6px;

  @media only screen and ${deviceMax.mobileL} {
    padding: 10px 34px;
  }
`;

export const ButtonNo = styled.button`
  background: none;
  color: ${COLORS.mainColor};
  padding: 10px 50px;
  border-radius: 6px;
  border: 1px solid ${COLORS.mainColor};

  @media only screen and ${deviceMax.mobileL} {
    padding: 10px 34px;
  }
`;
